import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCreateCustomer = (callback: (id: string) => void) => {
  const queryClient = useQueryClient();

  return apiClient.customer.createCustomer.useMutation({
    onSuccess: (res: any) => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      callback(res.body.data._id);
      toast.success('Customer created successfully!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error creating the customer!');
    },
  });
};
